module.exports = __webpack_public_path__ + "static/media/UnduMakeupRemover.bcbd383e.jpg";